import React, { useEffect, useState, createContext } from "react";

import {
  Header,
  About,
  Hero,
  Projects,
  Contact,
  Footer,
  Social,
} from "./pages/index.js";

export const ThemeContext = createContext(null);

const App = () => {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const localTheme = localStorage.getItem("theme");
    if (localTheme) {
      setTheme(localTheme);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevState) => (prevState === "light" ? "dark" : "light"));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <div className="app" id={theme}>
        {/* <SmoothScroll /> */}
        {/* <ScrollTop /> */}
        <Header />
        <Hero />
        <About />
        <Projects />
        <Contact />
        <Social />
        <Footer />
      </div>
    </ThemeContext.Provider>
  );
};

export default App;
